import { gql } from '@apollo/client';

export const GET_SUMMARY_REPORT_CSV = gql`
  query getFintelChecksCSV($input: FintelCheckSearchInput!) {
    fintelChecksCSV(input: $input) {
      fintelChecks {
        id
        publisherName
        publisherId
        productCategory
        customizedProductId
        productName
        pageCount
        passCount
        failCount
        reviewCount
        incompleteCount
        nfCount
      }
    }
  }
`;
